

const SERVER_URLS = {
  local: "https://localhost:8080",
  test: "https://api-test.gotagtech.com:8080",
  prod: "https://app.gotagtech.com:8080",
  staging: "https://staging.pageflow.com:8080",
  default: "http://localhost:8080"
}

const DEBUG_STATES = {
  local: true,
  test: false,
  prod: false,
  default: false
}


//process.env.REACT_APP_BACKEND == "dev" ? "http://127.0.0.1:8080" : "https://api-dev.gotagtech.com:8080";

export const SERVER_URL = SERVER_URLS[process.env.REACT_APP_BACKEND] || SERVER_URLS.default;
export const DEBUG_STATE = DEBUG_STATES[process.env.REACT_APP_BACKEND] || DEBUG_STATES.default;

/* TODO can we define SERVER_URL based on env variable?
Possible way is to have multiple build commands
So like
"build:dev": "REACT_APP_SERVER=dev npm run build"
*/

// define some globals here.
export const IDENTITY_AND_INSURANCE_PAGE_GROUP_ID = 110558
